export default __webpack_public_path__ + "images/assets/790648948283f501479fb5c622efd7b8.svg";